export default __webpack_public_path__ + "static/media/screenShots_new-year-3.97161bf9.jpg";